import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAll,
    GetFieldsByCollectionPoint,
    GetDivisionByEstateID,
    GetEODDetailsReportData,
    GetMobileSessionsForWeighReport,
    GetAvialableFieldsForDropdown
};

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let array = [];
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function getAll() {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    return response.data;
}

async function GetDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}

async function GetEODDetailsReportData(data) {
    const searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID,
        fieldID: data.fieldID,
        status: parseInt(data.status),
        // sessionID: data.sessionID === "0" ? null : data.sessionID,
        // pluckingType: data.pluckingType == 0 ? null : data.pluckingType,
        searchDate: data.searchDate
    }
    const response = await CommonPost('/api/EODDetailsReport/GetEODDetailsReportData', null, searchData);
    return response.data;
}

const convertFrom24To12Format = (time24) => {
    const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
    const period = +sHours < 12 ? 'AM' : 'PM';
    const hours = +sHours % 12 || 12;

    return `${hours}:${minutes} ${period}`;
}

async function GetMobileSessionsForWeighReport(data) {
    var array = [];
    const searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID,
        fieldID: data.fieldID,
        searchDate: data.searchDate
    }
    const response = await CommonPost('/api/WeighingReport/GetMobileSessionsForWeighReport', null, searchData);
    for (let item of Object.entries(response.data)) {
        var time = convertFrom24To12Format(item[1]["sosTime"].split('T')[1].split('.')[0]);
        array[item[1]["mobileSessionID"]] = item[1]["sessionName"] + " Time: " + time;
    }
    return array;
}

async function GetAvialableFieldsForDropdown(data) {
    var fieldArray = [];
    const searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID,
        searchDate: data.searchDate === "" ? null : data.searchDate
    }

    const response = await CommonPost('/api/WeighingReport/GetFieldsForCheckRollWeighmentReport', null, searchData);
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return fieldArray;
}